module.exports = __webpack_public_path__ + "static/img/img2.73d6abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/img2.png
// module id = yeRS
// module chunks = 0